import { CheckCircle, XCircle } from 'phosphor-react'
import { toast } from 'react-toastify'

import { type ExpertDomain } from '../../../../../../types/domain/expert-domain'
import { useExpertInternationalBankDataMutation } from '../../../../../../services/hooks/experts/mutations/useExpertInternationalBankDataMutation'
import { InternationalBankDataForm } from '../../../../../../components/Forms/InternationalBankDataForm'
import { getErrorMessage } from '../../../../../../utils/getErrorMessage'

interface Props {
  data?: ExpertDomain
  save: () => void
}

export const InternationalBankForm = ({ data, save }: Props) => {
  const { mutate, isLoading } = useExpertInternationalBankDataMutation()

  const onSaveExpert = (values: any) => {
    if (data?.id) {
      mutate(
        { id: data?.id, data: values },
        {
          onSuccess(result) {
            toast('Dados bancários salvos com sucesso!', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              closeButton: false,
              icon: (
                <CheckCircle
                  size={48}
                  className="mx-auto my-auto text-alert-success"
                />
              ),
              className: 'bg-green-50',
            })

            save()
          },
          onError(error: unknown) {
            toast(getErrorMessage(error), {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              closeButton: false,
              icon: (
                <XCircle
                  size={48}
                  className="mx-auto my-auto text-alert-error"
                />
              ),
              className: 'bg-red-50',
            })
          },
        }
      )
    }
  }

  return (
    <InternationalBankDataForm
      isSubmitting={isLoading}
      defaultValues={{
        swiftCode: data?.bankData?.swiftCode ?? '',
        bankAccountNumber: data?.bankData?.bankAccountNumber ?? '',
        internationalBankBranch: data?.bankData?.internationalBankBranch ?? '',
        amazonGiftCardEmail: data?.bankData?.amazonGiftCardEmail ?? '',
      }}
      onSubmit={onSaveExpert}
    />
  )
}
